import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';

// Define the GraphQL query for fetching emergency contacts
const getEmergencyContactsQuery = graphql(/* GraphQL */ `
  query emergencyContactsByUserId($userId: String!) {
    emergencyContactsByUserId(userId: $userId) {
      contactId
      userId
      fullName
      phone
    }
  }
`);

// Custom hook for fetching emergency contacts
const useGetEmergencyContacts = (userId: string, enabled: boolean = true) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    emergencyContactsByUserId: {
      contactId: number;
      userId: string;
      fullName: string;
      phone: string;
    } | null;
  }>({
    queryKey: ['emergencyContacts', userId],
    queryFn: async () =>
      graphqlRequest(
        getEmergencyContactsQuery,
        { userId },
        enabled && isAuthenticated ? getAccessTokenSilently : undefined,
      ),
    enabled: enabled && isAuthenticated,
    retry: shouldRetryQuery,
  });

  const emergencyContacts = data?.emergencyContactsByUserId;

  return {
    emergencyContacts,
    isLoading,
    isError: !!error,
    error,
    refetch,
    isFetching,
  };
};

export default useGetEmergencyContacts;
